module.exports = __webpack_public_path__ + "img/logo.407e9314.svg";